import { sql } from "drizzle-orm"
import {
  pgSchema,
  index,
  uniqueIndex,
  timestamp,
  jsonb,
  varchar,
  integer,
} from "drizzle-orm/pg-core"
import { id_length, ulidId } from "./shared"

export const rulesSchema = pgSchema("rules")

export const decisionTableRevision = rulesSchema.table(
  "decision_table_revision",
  {
    id: ulidId(),
    decisionTableId: varchar("decision_table_id", {
      length: id_length,
    }).notNull(),
    revision_number: integer("revision_number").notNull(),
    status: varchar("status").notNull(),
    title: varchar("title").notNull(),
    description: varchar("description").notNull(),
    rows: jsonb("rows").notNull(),
    expectations: jsonb("expectations").notNull(),
    createdAt: timestamp("created_at").defaultNow().notNull(),
    updatedAt: timestamp("updated_at").defaultNow().notNull(),
    updatedBy: varchar("updated_by").notNull().default(""),
  },
  (table) => {
    return {
      decisionTableId: index("idx_decision_table").on(table.decisionTableId),
      onlyOneApproved: uniqueIndex("idx_approved_decision_table_revision")
        .onOnly(table.decisionTableId, table.status)
        .where(sql`status = 'APPROVED'`),
    }
  },
)
